import { Dynamic } from "solid-js/web";
import { mergeProps, createEffect, onMount, splitProps } from "solid-js";
import Quill from "quill";
function kebabCase(input) {
    return input
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/\s+/g, "-")
        .toLowerCase();
}
const defaultValues = {
    theme: "snow",
    formats: [
        "bold",
        "italic",
        "underline",
        "strike",
        "align",
        "list",
        "indent",
        "size",
        "header",
        "link",
        "image",
        "video",
        "color",
        "background",
    ],
    modules: {
        toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["link", "image", "video"],
            [{ color: [] }, { background: [] }],
            ["clean"],
        ],
        clipboard: {
            matchVisual: false,
        },
    },
};
const events = [
    "onEditorChange",
    "onScrollBeforeUpdate",
    "onScrollBlotMount",
    "onScrollBlotUnmount",
    "onScrollOptimize",
    "onScrollUpdate",
    "onScrollEmbedUpdate",
    "onSelectionChange",
    "onTextChange",
    "onCompositionBeforeStart",
    "onCompositionStart",
    "onCompositionBeforeEnd",
    "onCompositionEnd",
];
export function SolidQuill(props) {
    let quill;
    let editorRef;
    const mergedProps = mergeProps({ as: "div", ...defaultValues }, props);
    const [internal, otherProps] = splitProps(mergedProps, [
        "as",
        "ref",
        "onReady",
        ...events,
    ]);
    const [quillProps, externalProps] = splitProps(otherProps, [
        "debug",
        "modules",
        "placeholder",
        "readOnly",
        "theme",
        "formats",
        "bounds",
    ]);
    onMount(() => {
        quill = new Quill(editorRef, quillProps);
        for (const event of events) {
            if (!internal[event])
                continue;
            const [modifier, ...eventParts] = kebabCase(event).split("-");
            quill[modifier](eventParts.join("-"), internal[event]);
        }
        if (internal.ref && typeof internal.ref === "function") {
            internal.ref(quill);
        }
        if (internal.onReady) {
            internal.onReady(quill);
        }
    });
    createEffect(() => {
        const state = quillProps.readOnly ? "disable" : "enable";
        quill[state]();
    });
    return (<Dynamic ref={editorRef} class="quill" component={internal.as} {...externalProps}/>);
}
